var exports = {
  "kL": "xcc377c0b--3aad01--container",
  "wx": "xcc377c0b--3aad01--header",
  "Qs": "xcc377c0b--3aad01--content",
};

module.exports = exports;
